module.exports = __webpack_public_path__ + "static/media/ua_emergencias_24.241e386e.svg";